import { TextInput } from '@optimus-web/core';
import { connectCheckoutField } from '../../utils/connectCheckoutField';

export const CheckoutInput = connectCheckoutField()(TextInput);
